import {Injectable} from '@angular/core';
import {UserService} from './user.service';
import {takeWhile, scan, take} from 'rxjs/operators';
import {merge, from, ReplaySubject} from 'rxjs';
import {AbstractRoleProvider} from '../../requests/classes/role-provider';

@Injectable({
  providedIn: 'root'
})

export class UserPermissionsService {
  private userRoles: string[] = [];
  private userRolesSubject = new ReplaySubject<string[]>(1);
  // tslint:disable-next-line:no-unused-variable
  private currentUserName: string;

  constructor(private userService: UserService) {
    this.setUserNameSubscription();
  }

  public setUserRoles(roles: string[]): void {
    this.userRoles = roles;
    this.userRolesSubject.next(roles);
  }

  public getUserRoles(): string[] {
    return this.userRoles;
  }

  public async isActionAvailable(permission: string|Array<string>, roleProvider?: AbstractRoleProvider): Promise<boolean> {
    const userRoles = await this.userRolesSubject.pipe(take(1)).toPromise();
    if (!permission?.length) {
      return true;
    }

    if (Array.isArray(permission)) {
      const permissionChecks = permission.map(p => from(this.isActionAvailable(p, roleProvider)));
      // actionAvailable
      return merge(...permissionChecks)
        .pipe(
          takeWhile(permissionAllowed => permissionAllowed !== true, true),
          scan((acc, permissionAllowed) => acc || permissionAllowed, false)
        ).toPromise();
    }
    const specificRoles = roleProvider ? await roleProvider.getRoles() : [];

    return [...specificRoles, ...userRoles].includes(permission);
  }
  private setUserNameSubscription(): void {
    this.userService.usernameChange()
      .subscribe(name => this.currentUserName = name);
  }
}
